import * as React from "react";
import type { ComponentProps } from "react";

import { cn } from "@eisox/design-system";
import { createLink, type LinkComponent } from "@tanstack/react-router";

const NAME = "Navlink";

const navlinkClassName =
  "ml-2.5 font-normal block text-base whitespace-nowrap no-underline outline-none hover:no-underline";

const NavlinkAnchor = React.forwardRef<HTMLAnchorElement, React.AnchorHTMLAttributes<HTMLAnchorElement>>(
  (props, ref) => <a ref={ref} {...props} />,
);

NavlinkAnchor.displayName = "NavlinkAnchor";

const NavlinkLink = createLink(NavlinkAnchor);

const Navlink: LinkComponent<typeof NavlinkAnchor> = props => {
  const { className, ...rest } = props as ComponentProps<typeof NavlinkLink> & { className?: string };

  return (
    <NavlinkLink
      {...rest}
      className={cn(navlinkClassName, className)}
      inactiveProps={{ className: "text-primary-dark-blue" }}
      activeProps={{ className: "text-primary-blue" }}
    />
  );
};

(Navlink as { displayName?: string }).displayName = NAME;

export { Navlink };
